export const DIMENSION_GERAL = 'geral';
export const DIMENSION_FINALIDADE = 'finalidade';
export const DIMENSION_TIPO_VEICULO = 'tipoVeiculo';
export const DIMENSION_CATEGORIA = 'categoriaVeiculo';

export const SEGMENT_ALL = 'ALL';

export const DIMENSION_TABS = [
  { id: DIMENSION_GERAL, label: 'Geral' },
  { id: DIMENSION_FINALIDADE, label: 'Finalidade' },
  { id: DIMENSION_TIPO_VEICULO, label: 'Proprietário' },
  { id: DIMENSION_CATEGORIA, label: 'Categoria' },
];

/** Chave em `segmentos` na response da API. */
export const DIMENSION_TO_SEGMENTOS_KEY = {
  [DIMENSION_FINALIDADE]: 'finalidade',
  [DIMENSION_TIPO_VEICULO]: 'tipoVeiculo',
  [DIMENSION_CATEGORIA]: 'categoriaVeiculo',
};

/** Campo do body enviado à API ao selecionar um segmento específico. */
export const DIMENSION_TO_API_FILTER_KEY = {
  [DIMENSION_FINALIDADE]: 'finalidades',
  [DIMENSION_TIPO_VEICULO]: 'tipoVeiculos',
  [DIMENSION_CATEGORIA]: 'categoriaVeiculos',
};

export const isModularDimension = (dim) =>
  dim && dim !== DIMENSION_GERAL;

export const isSegmentFilterActive = (dim, seg) =>
  isModularDimension(dim) && seg && seg !== SEGMENT_ALL;

const DESCRIPTIONS = {
  [DIMENSION_GERAL]: {
    [SEGMENT_ALL]:
      'Custos consolidados de toda a frota no período. O ranking destaca os veículos individuais com maior gasto.',
  },
  [DIMENSION_FINALIDADE]: {
    [SEGMENT_ALL]:
      'Compare o custo total entre finalidades. Selecione uma finalidade para ver KPIs, gráficos e transações apenas daquele grupo.',
    _segment:
      'Exibindo apenas veículos de finalidade **{label}**. Valores abaixo refletem somente este recorte.',
  },
  [DIMENSION_TIPO_VEICULO]: {
    [SEGMENT_ALL]:
      'Compare custos entre veículos Eletropontes, Particulares e Alugados.',
    _segment:
      'Exibindo apenas veículos **{label}**.',
  },
  [DIMENSION_CATEGORIA]: {
    [SEGMENT_ALL]:
      'Compare custos por tipo de veículo (carro, caminhão, moto…).',
    _segment:
      'Exibindo apenas veículos da categoria **{label}**.',
  },
};

export const getSegmentDescription = (dim, seg, segmentLabel) => {
  const dimMap = DESCRIPTIONS[dim];
  if (!dimMap) return '';

  if (!isModularDimension(dim) || seg === SEGMENT_ALL) {
    return dimMap[SEGMENT_ALL] || '';
  }

  const template = dimMap._segment || '';
  return template.replace('{label}', segmentLabel || seg);
};

export const getSegmentFilterLabel = (dim, seg, segmentLabel) => {
  if (!isSegmentFilterActive(dim, seg)) return null;
  const tab = DIMENSION_TABS.find((t) => t.id === dim);
  const dimLabel = tab?.label || dim;
  return `${dimLabel}: ${segmentLabel || seg}`;
};

/** Opções fixas para chips quando a API não retorna segmentos (Proprietário e Categoria). */
export const STATIC_SEGMENT_OPTIONS = {
  [DIMENSION_TIPO_VEICULO]: [
    { key: 'ELETROPONTES', label: 'Eletropontes' },
    { key: 'PARTICULAR', label: 'Particular' },
    { key: 'ALUGADO', label: 'Alugado' },
  ],
  [DIMENSION_CATEGORIA]: [
    { key: 'CARRO', label: 'Carro' },
    { key: 'CAMINHAO', label: 'Caminhão' },
    { key: 'UTILITARIO_CAMINHONETE', label: 'Caminhonete' },
    { key: 'MAQUINA', label: 'Máquina' },
    { key: 'MOTO', label: 'Moto' },
    { key: 'REBOQUE', label: 'Reboque' },
  ],
};
